import clsx from 'clsx'
import { ChevronsUpDown } from 'lucide-react'
import * as React from 'react'

import { type ComboboxFilterOption } from '../../reusable/table/ComboboxMultiSelectFilter'

type FilterManagementDropdownProps<T> = {
  noSelectionText?: string
  pluralIdentifier?: string
  selectedValues: T[]
  options: ComboboxFilterOption<T>[]
  width?: string
  open?: boolean
  children?: React.ReactNode
  excludedValues?: T[]
}

const FilterManagementDropdown = <T,>({
  selectedValues = [],
  noSelectionText = 'Select option...',
  pluralIdentifier = 'options',
  width = '300px',
  options,
  open,
  children,
}: FilterManagementDropdownProps<T>) => {
  return (
    <div
      role='combobox'
      aria-expanded={open}
      style={{ width }}
      className={clsx({
        'rounded-md bg-slate-50 flex items-center justify-between px-2 py-1 text-sm': true,
        'text-thatch-purple': selectedValues.length > 0,
        'text-ds-text-secondary': selectedValues.length === 0,
      })}
    >
      <span className='truncate'>
        {getSelectedOutput(
          selectedValues,
          options,
          noSelectionText,
          pluralIdentifier
        )}
      </span>
      <span>
        {children || <ChevronsUpDown size={20} />}
      </span>
    </div>
  )
}

function getSelectedOutput<T> (
  selectedValues: T[] = [],
  options: ComboboxFilterOption<T>[],
  noSelectionText: string,
  pluralIdentifier: string
) {
  if (selectedValues?.length === 0) {
    return noSelectionText
  }

  if (selectedValues?.length === 1) {
    return options.find((option) => selectedValues?.includes(option.value))
      ?.label
  }

  return `${selectedValues?.length} ${pluralIdentifier} selected`
}

export default FilterManagementDropdown
